import { render, staticRenderFns } from "./mediaPlatformConfirm.vue?vue&type=template&id=044c2cc0&scoped=true&"
import script from "./mediaPlatformConfirm.vue?vue&type=script&lang=js&"
export * from "./mediaPlatformConfirm.vue?vue&type=script&lang=js&"
import style0 from "./mediaPlatformConfirm.vue?vue&type=style&index=0&id=044c2cc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c2cc0",
  null
  
)

component.options.__file = "mediaPlatformConfirm.vue"
export default component.exports